export default __webpack_public_path__ + "static/media/minigame_background.df406fe9.png";